import { cn } from '../../lib/cn';
import type { UATSessionRow } from '../../enterpriseacceptance/framework';

type Props = { sessions?: UATSessionRow[] };

export function UserAcceptancePanel({ sessions = [] }: Props) {
  return (
    <div className="space-y-2">
      {sessions.map((s) => (
        <div key={s.department} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <div>
              <p className="text-sm font-medium">{s.department}</p>
              <p className="text-xs text-slate-500">{s.passed}/{s.scenarios} scenarios passed</p>
            </div>
            <span className={cn(
              'shrink-0 rounded-full px-2 py-0.5 text-xs font-medium',
              s.status === 'signed_off' ? 'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300' :
              'bg-brand-50 text-brand-700 dark:bg-brand-950 dark:text-brand-300',
            )}>
              {s.status.replace('_', ' ')}
            </span>
          </div>
          <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-slate-100 dark:bg-slate-800">
            <div className="h-full rounded-full bg-brand-500" style={{ width: `${(s.passed / s.scenarios) * 100}%` }} />
          </div>
        </div>
      ))}
    </div>
  );
}
